var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProximamente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 178.585,
    height: 122.52,
    viewBox: "0 0 178.585 122.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f0f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16025",
    "data-name": "Grupo 16025",
    transform: "translate(-2.781 -0.118)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1523",
    "data-name": "Elipse 1523",
    cx: 61.273,
    cy: 61.26,
    rx: 61.273,
    ry: 61.26,
    transform: "translate(37 0.118)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16004",
    "data-name": "Grupo 16004",
    transform: "translate(9.594 16.902) rotate(9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76902",
    "data-name": "Trazado 76902",
    d: "M2.169,26.29,165.057.048A3.679,3.679,0,0,1,169.229,4.5l-7.837,34.2a7.821,7.821,0,0,1-6.677,6.016L18.724,61.28a6.846,6.846,0,0,1-6.691-3.262L.372,30.165A2.577,2.577,0,0,1,2.169,26.29Z",
    transform: "translate(4.589 0)",
    fill: "#ee2b7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PROXIMAMENTE",
    transform: "translate(31.305 45.37) rotate(-8.43)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Montserrat-BlackItalic, Montserrat",
    fontWeight: 800,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PROXIMAMENTE")), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76903",
    "data-name": "Trazado 76903",
    d: "M3.358,4.756.425,2.555A1.065,1.065,0,0,1,.213,1.064h0A1.065,1.065,0,0,1,1.7.852L3.358,2.093a1.065,1.065,0,0,0,1.278,0L7.142.213a1.065,1.065,0,0,1,1.278,0l2.507,1.881a1.065,1.065,0,0,0,1.278,0L14.713.213a1.064,1.064,0,0,1,1.278,0L18.5,2.094a1.064,1.064,0,0,0,1.277,0L22.285.213a1.064,1.064,0,0,1,1.277,0l2.936,2.2A1.065,1.065,0,0,1,26.711,3.9h0a1.065,1.065,0,0,1-1.49.213L23.562,2.874a1.064,1.064,0,0,0-1.277,0l-2.51,1.882a1.064,1.064,0,0,1-1.278,0L15.99,2.875a1.064,1.064,0,0,0-1.278,0L12.2,4.756a1.065,1.065,0,0,1-1.278,0L8.42,2.875a1.065,1.065,0,0,0-1.278,0L4.636,4.755A1.064,1.064,0,0,1,3.358,4.756Z",
    transform: "translate(150.978 35.682)",
    fill: "#b1e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76904",
    "data-name": "Trazado 76904",
    d: "M13.2,5.181H2.59A2.59,2.59,0,0,1,0,2.591H0A2.59,2.59,0,0,1,2.59,0H13.2a2.59,2.59,0,0,1,2.59,2.591h0A2.59,2.59,0,0,1,13.2,5.181Z",
    transform: "translate(0 34.713)",
    fill: "none",
    stroke: "#e0f2f2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76905",
    "data-name": "Trazado 76905",
    d: "M3.458,6.927a3.464,3.464,0,0,1-2.7-5.622A3.464,3.464,0,0,1,6.173,5.621,3.482,3.482,0,0,1,3.458,6.927Zm.01-5.506a2.054,2.054,0,0,0-.233.014A2.041,2.041,0,0,0,2.192,5.06a2.041,2.041,0,0,0,3.3-1.826h0A2.042,2.042,0,0,0,3.468,1.422Z",
    transform: "translate(15.817 14.449)",
    fill: "#f8b8d1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProximamente);
export default __webpack_public_path__ + "static/media/proximamente.bd66d9774fd1193f1c15c8cfd87e148f.svg";
export { ForwardRef as ReactComponent };